import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResourceGroupsComponent} from './resource-groups.component';
import {ResourceGroupsSummaryComponent} from './resource-groups-summary/resource-groups-summary.component';
import {ResourceGroupsDialogComponent} from './resource-groups-dialog/resource-groups-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {FlexModule} from '@angular/flex-layout';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ResourceGroupsSearchComponent} from './resource-groups-search/resource-groups-search.component';
import {MaterialModule} from '../../material.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {InfraModule} from 'ac-infra';

@NgModule({
  declarations: [
    ResourceGroupsComponent,
    ResourceGroupsSummaryComponent,
    ResourceGroupsDialogComponent,
    ResourceGroupsSearchComponent
  ],
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        FlexModule,
        LayoutModule,
        SearchModule,
        ActionBarModule,
        MaterialModule,
        ArmTableModule,
        InfraModule
    ]
})
export class ResourceGroupsModule { }
